import { type MonetaryValue } from 'ezmoney';

import { useQuery } from 'src/core/api/hooks/useQuery';
import type { QueryState } from 'src/core/api/queryState';

export type PriceMigrationPlan = {
  type: '2025-PricingIncrease-Trial' | 'Annual-Price-Increase';
  estimate: MonetaryValue;
  current: MonetaryValue;
  migrationDate: string;
  planItems?: {
    estimate: MonetaryValue;
    current: MonetaryValue;
    companyId: string;
    companyName: string;
  }[];
};

type Result =
  | {
      migrationPending: false;
    }
  | {
      migrationPending: true;
      migrationPlan: PriceMigrationPlan;
    };

export const useGetBillingMigration = (
  companyId: string,
  isEnabled: boolean = true,
): QueryState<Result> => {
  return useQuery({
    key: ['billing', 'migration', companyId],
    isEnabled,
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: 'billing/migration',
    },
    options: {
      staleTime: 1000 * 60 * 10,
      cacheTime: 1000 * 60 * 10,
    },
  });
};
